import { MainBreadcrumbItem } from '../../MainBreadcrumb/MainBreadcrumb';
import React, { useContext, useEffect, useState } from 'react';
import { SelectedMenuContext } from '../../../contexts/selectedMenu.context';
import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import { ForkliftInterface } from '../../../types/forklift.interface';
import { fetcher } from '../../../extras/fetcher';
import { ColumnsType } from 'antd/es/table';
import { myNumberSorter, myStringSorter } from '../../../extras/sorters';

import { PermError } from '../NotFoundPage/PermError';
import { DeleteForklift } from './DeleteForklift';
import { TableHeader } from '../Ikea/Stan/TableHeader';
import { Button, message, SelectProps, Table, Tag } from 'antd';
import { AlertOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { LastInspectionDate } from './LastInspectionDate';
import { ForkliftAlertInterface } from '../../../types/forkliftAlert.interface';
import { UsersInterface } from '../../../types/users.interface';
import { DeleteNotification } from './DeleteNotification';
import { ModalAddNotification } from './ModalAddNotification';

interface Props {
  handleSetMainTitle: (title: string) => void;
  setBreadcrumbHandler: (items: MainBreadcrumbItem[] | null) => void;
}

export type AddNotificationType =
  Omit<ForkliftAlertInterface, 'id' | 'users' | 'forklifts'> & {
  id?: string;
  forkliftIds: string[];
  userIds: string[];
};

export const ForkliftNotification = (props: Props) => {

  const [loading, setLoading] = useState<boolean>(false);
  const selectedMenuContext = useContext(SelectedMenuContext);
  const { windowHeight } = useWindowDimensions();
  const [permError, setPermError] = useState<boolean>(false);
  const [tableData, setTableData] = useState<ForkliftAlertInterface[]>([]);
  const [notification, setNotification] = useState<AddNotificationType>({
    id: '',
    active: true,
    forkliftIds: [],
    hours: 24,
    userIds: [],
    withoutWeekends: true,
  });

  const [modalAddNotificationOpened, setModalAddNotificationOpened] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();



  const getData = async () => {

    setLoading(true);

    const data = await fetcher(`forklift/alert`);
    if(data.status === 403) {
      setPermError(true);
      return;
    }

    const result: ForkliftAlertInterface[] = data.result;

    setTableData(result);
    setLoading(false);


  }


  useEffect(() => {
    getData();
  },[]);


  useEffect(() => {
    const breadcrumbItems: MainBreadcrumbItem[]=[
      {
        href: '',
        key: 'forklift',
        label: 'Przegląd Wózków',
      },
      {
        href: '/forklift/alerts',
        key: 'forklift_alerts',
        label: 'Powiadomienia',
      },
    ];


    props.handleSetMainTitle('Przegląd Wózków - Powiadomienia');
    props.setBreadcrumbHandler(breadcrumbItems);

    selectedMenuContext?.setSelectedKey(['forklift_alerts']);

  },[]);


  const columns: ColumnsType<ForkliftAlertInterface> = [

    {
      title: 'Aktywne',
      width: 80,
      dataIndex: 'active',
      align: 'center',
      render: (value, record) => <Tag color={record.active ? 'success' : 'error'}>
        {record.active ? 'TAK' : 'NIE'}
      </Tag>
    },

    {
      title: 'Po ilu godzinach',
      width: 150,
      dataIndex: 'hours',
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Bez weekendów',
      width: 150,
      dataIndex: 'withoutWeekends',
      render: (value) => value ? 'TAK' : 'Nie',
    },

    {
      title: 'Wózki Widłowe',
      minWidth: 250,
      dataIndex: 'forklifts',
      render: (value: ForkliftInterface[]) => {
        if(value) {
           return value.map((x) => <Tag style={{marginLeft: 10}}>{x.number}</Tag>)
        }
      }

    },

    {
      key: 'users',
      title: 'Użytkownicy',
      minWidth: 250,
      dataIndex: 'users',
      render: (value: UsersInterface[]) => {
        if(value) {
          return value.map((x) => <Tag style={{marginLeft: 10}}>{x.firstname+' '+x.lastname}</Tag>)
        }
      }

    },





    {
      width: 100,
      title: '',
      align: 'center',
      filterMode: 'tree',
      render: (value, record) =>  <div style={{display: 'flex', gap: 5, justifyContent: 'center', alignContent: 'center'}}><Button icon={<EditOutlined />} onClick={() => handleEditForkliftButton(record)}/><DeleteNotification messageApi={messageApi} id={record.id} getData={getData} /></div>

    },


  ];



  const handleEditForkliftButton = (selectedNotification: ForkliftAlertInterface) => {

    const forkliftIds: string[] = selectedNotification.forklifts.map((forklift: ForkliftInterface) => forklift.id);
    const userIds: string[] = selectedNotification.users.map((user: UsersInterface) => user.id);

    const {forklifts, users, ...data} = selectedNotification;

    setNotification({
      ...data,
      forkliftIds,
      userIds,
      active: selectedNotification.active ? true : false,
    });
    setModalAddNotificationOpened(true);
  }


  const updateNotification = (updAlert: ForkliftAlertInterface) => {
    setTableData((prev) => {

      if(prev.findIndex((x) => x.id === updAlert.id) === -1) {
        const data = prev;

        data.push(updAlert);
        return data;
      } else {

        const data = prev.map((x) => {
          if(x.id === updAlert.id) {
            return {
              x,
              ...updAlert,
            }
          } else {
            return x
          }
        })

        return data;

      }

    })
  }


  const handleAddNotificationButton = () => {
    setNotification({
      id: '',
      active: true,
      userIds: [],
      hours: 24,
      forkliftIds: [],
      withoutWeekends: true,
    });

    setModalAddNotificationOpened(true);

  }


  if(permError) {
    return <PermError/>
  }


  return (
  <>
    <Table
      rowKey={'id'}
      title={(records) => <TableHeader getData={getData} selectedCount={0} additional={<><Button icon={<PlusOutlined />} onClick={handleAddNotificationButton}>Dodaj Powiadomienie</Button></>}/> } columns={columns} scroll={{ y: windowHeight *.6}} pagination={false} loading={loading} showHeader={true} bordered={true} dataSource={tableData} style={{opacity: 0.9}} size={'small'} />


    <ModalAddNotification notification={notification} handleSetData={updateNotification} handleSetModalOpened={setModalAddNotificationOpened} open={modalAddNotificationOpened} />
    {contextHolder}
  </>

  )



}
